import { render, staticRenderFns } from "./TabledataField.vue?vue&type=template&id=6466d3c4&scoped=true&"
import script from "./TabledataField.vue?vue&type=script&lang=js&"
export * from "./TabledataField.vue?vue&type=script&lang=js&"
import style0 from "./TabledataField.vue?vue&type=style&index=0&id=6466d3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6466d3c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
